import { Row , Col } from '../grid'
import './style.scss'

const responsive = {
  1: { xs: 24 },
  2: { xs: 24, sm: 12 },
  3: { xs: 24, sm: 12, md: 8 },
  4: { xs: 24, sm: 12, md: 6 },
  0: { xs: 24, sm: 24, md: 24}
}

export const DetailListItem = {
  name: 'DetailListItem',
  props: {
    title:{
      default:''
    },
    label:{
      default:''
    },
    colon:{
      default:true
    },
    margin:{
      default:true
    },
    content:null,
    html:false,
    labelStyle:{
      default(){
        return {

        }
      }
    }
  },
  inject: {
    col: {
      type: Number
    },
    labelWidth:{
      type:[Number , String]
    },
    labelAlign:{
      type:String
    },
    itemStyle:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  render () {
    const { $scopedSlots , html } = this

    let style = {}
    if( this.labelWidth ) style.width = this.labelWidth
    if( this.labelAlign ) style.textAlign = this.labelAlign
    if( this.labelStyle ) {
      style = Object.assign(style , this.labelStyle )
    }

    const title = this.title || this.label
    const titleEl = 
      $scopedSlots.title ? 
        <div class="title" style={style}>{ $scopedSlots.title() }</div> : 
      title ? 
        <div class="title" style={style}>{title}</div> : 
      null
    const content = this.content ? this.content : $scopedSlots.default ? $scopedSlots.default() : null
    return (
      <Col class={['sl-detail-list-item', !this.margin ? 'no-margin' : '', this.colon ? 'colon' : '']} style={this.itemStyle} {...{ props: responsive[this.col] }}>
        {titleEl}
        {
          html ? <div class="content" domPropsInnerHTML={content}></div> : <div class="content">{content}</div>
        }
      </Col>
    )
  }
}

export const DetailList = {
  name: 'DetailList',
  Item: DetailListItem,
  components: {},
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    col: {
      type: Number,
      required: false,
      default: 3
    },
    size: {
      type: String,
      required: false,
      default: 'default'
    },
    layout: {
      type: String,
      required: false,
      default: 'horizontal'
    },
    labelWidth:{
      default:'auto'
    },
    labelAlign:{
      default:'left'
    },
    itemStyle:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  provide () {
    return {
      col: this.col > 4 ? 0 : this.col,
      labelWidth: this.labelWidth,
      labelAlign: this.labelAlign,
      itemStyle:this.itemStyle
    }
  },
  render(){
    const { size , layout , title , $slots } = this
    const titleEl = title ? <div class="title">{ title }</div> : null
    const vnode = $slots.default
    return (
      <div class={['sl-detail-list', size, layout === 'vertical' ? 'vertical': 'horizontal']}>
        { titleEl }
        <Row type="flex" style="margin-left:0;margin-right:0;" gutter={16}>
          { vnode }
        </Row>
      </div>
    )
  }
}